import React, { useState, useRef } from "react";
import { DraggableCore } from "react-draggable";
import Box from "@mui/material/Box";

const styles = {
  resizable: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: -8,
    cursor: "ew-resize",
    display: "none",
    padding: "0 8px",
    ".resizableWrap:hover &": {
      display: "block",
    },
  },
  resizableIndicator: {
    margin: "0 auto",
    width: "1px",
    height: "100%",
    bgcolor: "grey.300",
  },
};

const ResizeBorder = ({
  onResizing,
  onStopReisizing,
  onMouseMove,
  onMouseOut,
  index,
  children,
}) => {
  const [initX, setInitX] = useState(0);
  const nodeRef = useRef(null);

  const onStartReisizing = index => (e, ui) => {
    setInitX(ui.lastX);
  };

  const onDragReisizing = index => (e, ui) => {
    onResizing(index, ui.lastX - initX);
    setInitX(ui.lastX);
  };

  return (
    <DraggableCore
      axis="x"
      onStart={onStartReisizing(index)}
      onDrag={onDragReisizing(index)}
      onStop={onStopReisizing}
      position={{ x: 0, y: 0 }}
      zIndex={999}
      nodeRef={nodeRef}
    >
      <Box
        ref={nodeRef}
        onMouseMove={onMouseMove}
        onMouseOut={onMouseOut}
        sx={styles.resizable}
      >
        <Box sx={styles.resizableIndicator} />
      </Box>
    </DraggableCore>
  );
};

export default ResizeBorder;
